<script setup lang="ts">
  import ContactMe from '@/components/common/ContactMe.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import { useRouter } from 'vue-router/composables'
  import useCourse from '@/composables/useCourse'
  import useIcons from '@/composables/useIcons'
  import useShopifyClient from '@/composables/useShopifyClient'

  import { UserModule } from '@/store/modules/user'

  const router = useRouter()
  const { isCourseExamTrialEnded } = useCourse()
  const { arrowRightIndicator } = useIcons()
  const { createShopifyCheckout } = useShopifyClient()

  const routeToExamStartPage = () => {
    router.push({ name: 'ExamStartPage' }).catch(() => {
      return
    })
  }
</script>

<template lang="pug">
.exam-trial-ended-wrapper(v-if='isCourseExamTrialEnded')
  h4.trial-ended-title {{ $t('courses.examSimulation.youHaveReachedTheEndOfTheExamTrial') }}
  h5.text {{ $t('courses.examSimulation.thankYouForTestingTheExamText', { name: UserModule.firstName }) }}
  .trial-ended-cta
    KetchUpButton.tertiary(@click.native='routeToExamStartPage')
      h4 {{ $t('previous') }}
    KetchUpButton.primary(@click.native='createShopifyCheckout')
      h4 {{ $t('courses.buyCourse') }}
      SVGRenderer(
        :icon='arrowRightIndicator',
        fill-color='var(--primary-foreground-color)',
        width='15px',
        :has-hover='false'
      )
  ContactMe
</template>

<style lang="postcss">
  .exam-trial-ended-wrapper {
    @apply ketch-flex ketch-flex-col ketch-space-y-c20;

    .trial-ended-title {
      @apply ketch-font-bold;
    }

    .trial-ended-cta {
      @apply ketch-flex ketch-items-center ketch-justify-between ketch-pb-c20 ketch-border-b ketch-border-border-color;

      button {
        @apply ketch-w-fit;
      }
    }

    .contact-me-wrapper {
      @apply ketch-rounded-large ketch-bg-tertiary-color ketch-p-c15 sm:ketch-p-c20;

      .background-overlay {
        @apply ketch-rounded-tl-large;
      }
    }
  }
</style>
